
export const galleryImages = [
  {
    title: 'Victorian Home Restoration',
    description: 'Complete exterior painting transformation in Springfield, MO',
    image: 'https://public.readdy.ai/ai/img_res/e50d9bc95ed40a923282f95ee466abd4.jpg'
  },
  {
    title: 'Modern Kitchen Refresh',
    description: 'Interior painting with custom color palette',
    image: 'https://readdy.ai/api/search-image?query=modern%20kitchen%20interior%20with%20freshly%20painted%20walls%20in%20soft%20gray%20color%20showing%20clean%20professional%20paint%20finish%20with%20white%20cabinets%20and%20contemporary%20design%20in%20residential%20home%20with%20simple%20minimal%20background&width=500&height=600&seq=gallery002&orientation=portrait'
  },
  {
    title: 'Estate Lawn Makeover',
    description: 'Weekly maintenance program results',
    image: 'https://readdy.ai/api/search-image?query=large%20estate%20property%20with%20perfectly%20manicured%20green%20lawn%20showing%20professional%20mowing%20patterns%20neat%20edges%20and%20beautiful%20landscaping%20in%20Missouri%20with%20house%20visible%20in%20background%20with%20simple%20minimal%20background&width=500&height=600&seq=gallery003&orientation=portrait'
  },
  {
    title: 'Colonial Revival',
    description: 'Historic home exterior painting project',
    image: 'https://readdy.ai/api/search-image?query=colonial%20style%20house%20with%20fresh%20white%20exterior%20paint%20and%20black%20shutters%20showing%20professional%20painting%20craftsmanship%20with%20brick%20walkway%20and%20landscaping%20in%20Missouri%20neighborhood%20with%20simple%20minimal%20background&width=500&height=600&seq=gallery004&orientation=portrait'
  },
  {
    title: 'Backyard Paradise',
    description: 'Complete landscaping design and installation',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20backyard%20landscape%20design%20with%20colorful%20flower%20beds%20green%20lawn%20decorative%20shrubs%20and%20mulch%20borders%20showing%20professional%20landscaping%20work%20in%20residential%20Missouri%20property%20with%20simple%20minimal%20background&width=500&height=600&seq=gallery005&orientation=portrait'
  },
  {
    title: 'Craftsman Charm',
    description: 'Exterior painting and deck staining combo',
    image: 'https://readdy.ai/api/search-image?query=elevated%20wooden%20deck%20with%20rich%20deep%20mahogany%20red%20brown%20stain%20finish%20showing%20glossy%20sealed%20surface%20with%20wooden%20railing%20posts%20and%20balusters%20professional%20deck%20staining%20results%20no%20people%20just%20the%20beautifully%20finished%20deck%20platform%20with%20simple%20minimal%20background&width=500&height=600&seq=gallery006-newdeck&orientation=portrait'
  },
  {
    title: 'Backyard Oasis',
    description: 'Complete patio and lawn transformation',
    image: 'https://static.readdy.ai/image/7012d1ed0225cfc4bba0161dc27b2468/bbe5ebc4876c9d59fb35401a8d35e2c3.png'
  }
];
